// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dataTable tbody td[data-v-4c623ab0]:hover{cursor:pointer}.clickFile[data-v-4c623ab0]:hover{color:#18e;cursor:pointer}", ""]);
// Exports
module.exports = exports;
